import {
	AlertBar,
	Anchor,
	Checkbox,
	FormattedText,
	FormItem,
	RadioButtonGroup,
	RadioButtonGroupItem,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { ReactElement, useState } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	ScimUserProvisioningSettingsSaveModel
} from "client/Api/UserProvisioningSettings/userProvisioningSettings";
import { TokenInput } from "./TokenInput";
import styles from "./UserProvisioningForm.module.less";
import { BILLING_SUPPORT_ARTICLE_URL } from "../Licensing/Licensing/Page";

export type ScimFormProps = {
	attachable: IValueInputAttachable<ScimUserProvisioningSettingsSaveModel>;
	hasAToken: boolean;
	onRegenerateToken(): void;
	shouldRenderTheAlert: boolean;
	onAlertDismissed(): void;
};

export const ScimForm = (props: ScimFormProps): ReactElement => {
	const {
		attachable,
		hasAToken,
		onRegenerateToken,
		shouldRenderTheAlert,
		onAlertDismissed
	} = props;

	const [isActivateByDefaultAlertDismissed, setIsActivateByDefaultAlertDismissed] = useState<boolean>(false);

	return (
		<>
			{shouldRenderTheAlert && (
				<div className={styles.alertContainer}>
					<AlertBar
						kind="info"
						onDismiss={onAlertDismissed}
						isInline
					>
						{localize("_AnAPIKeyWillBeGeneratedInfo")}
					</AlertBar>
				</div>
			)}
			<FormItem>
				<Checkbox
					{...attachable.for("isEnabled")
						.attachToCheckbox()}
					text={localize("_EnableSyncUsingSCIM")}
				/>
				<ValidationError
					{...attachable
						.for("isEnabled")
						.attachToValidationError()}
				/>
			</FormItem>
			<FormItem
				label={localize("_DefaultStatusForSyncedUsers")}
				isForGroup
			>
				<RadioButtonGroup
					{...attachable.for("shouldActivateUserByDefault")
						.attachToRadioButtonGroup()}
					options={activateUserOptions}
				/>
				<ValidationError
					{...attachable
						.for("shouldActivateUserByDefault")
						.attachToValidationError()}
				/>
				{ !isActivateByDefaultAlertDismissed && attachable.for("shouldActivateUserByDefault").value && (
					<div className={styles.activateByDefaultAlert}>
						<AlertBar
							kind="warning"
							onDismiss={() => setIsActivateByDefaultAlertDismissed(true)}
							isInline
							trackingId="activate-by-default-alert-bar"
						>
							<FormattedText
								text={localize("_ActivateUsersConfirmationDescription")}
								thingsToReplace={[
									{
										what: "{{Note}}",
										filler: <strong>{localize("_Note")}</strong>
									},
									{
										what: "{{ClickHere}}",
										filler: (
											<Anchor href={BILLING_SUPPORT_ARTICLE_URL} target="_blank">
												{localize("_ClickHere")}
											</Anchor>
										)
									}
								]}
							/>
						</AlertBar>
					</div>
				)}
			</FormItem>
			<TokenInput
				hasAToken={hasAToken}
				onRegenerateToken={onRegenerateToken}
				tokenLabel={localize("_SCIMAPIKey")}
			/>
		</>

	);
};
ScimForm.displayName = "ScimForm";

const activateUserOptions: RadioButtonGroupItem<boolean>[] = [
	{ text: localize("_Inactive"), value: false },
	{ text: localize("_Active"), value: true }
];